import React from 'react';
import { FallbackImage } from 'ui/UploadImage/fallBack/FallBackImage';
import { BreadCrumbData, QualityMarkProductData } from 'types/ProductData';
import { Tooltip } from 'ui';
import { StyledThirdHeader } from './style';

export interface ThirdHeaderProps {
  label: string;
  breadcrumb?: BreadCrumbData[];
  qmarks?: QualityMarkProductData[];
  unitType?: React.ReactNode;
  filters?: React.ReactNode;
  rightContent?: React.ReactNode;
  customClassName?: string;
}

export const DefaultThirdHeader = ({
  label,
  breadcrumb,
  qmarks,
  unitType,
  filters,
  rightContent,
  customClassName,
}: ThirdHeaderProps) => {
  return (
    <StyledThirdHeader className={customClassName}>
      <div className={'product-name-bread-wrapper d-flex flex-col'}>
        <div className="container">
          <div className={'product-name-and-qmarks-container d-flex flex-row'}>
            <div className={'product-name'}>
              {label} {unitType && unitType}
            </div>
            {rightContent ? (
              <div className={'right-content'}>{rightContent}</div>
            ) : (
              qmarks &&
              qmarks.length > 0 && (
                <div className={'qmarks'}>
                  {qmarks.map((qmark, index) => (
                    <Tooltip key={index} title={qmark.quality_mark?.name}>
                      <span>
                        <FallbackImage
                          src={
                            qmark.quality_mark?.logo
                              ? qmark.quality_mark.logo
                              : ''
                          }
                          type={'notFound'}
                          preview={false}
                          alt={qmark.quality_mark?.name}
                        />
                      </span>
                    </Tooltip>
                  ))}
                </div>
              )
            )}
          </div>
          <div className={'breadcrumbs-container'}>
            <div>
              {breadcrumb?.map((bread, index) => (
                <span key={index}>
                  <a href={bread.route}>{bread.name}</a>
                  {index < breadcrumb.length - 1 && (
                    <span className="breadcrumbs-icon">/</span>
                  )}
                </span>
              ))}
            </div>
            <div className={'filters-top-third'}>{filters}</div>
          </div>
        </div>
      </div>
    </StyledThirdHeader>
  );
};
